/** Matches app light-mode UI tokens (HomeView, EventListingView, WalletView). */
export const colors = {
  bg: '#f6f4f0',
  bgAlt: '#ffffff',
  ink: '#2C2A29',
  inkSoft: '#475569',
  inkMuted: '#64748b',

  /** Primary CTA — filled dark pill */
  primary: '#2C2A29',
  primaryText: '#f6f4f0',
  primaryHover: '#1a1918',

  /** Secondary — warm surface pill */
  secondary: '#f6f4f0',
  secondaryText: '#2C2A29',
  secondaryBorder: 'rgba(44, 42, 41, 0.14)',

  /** Teal accent from LightTheme.primary */
  accent: '#0F766E',
  accentSoft: '#ECFDF5',

  /** Merchant coupon tiers (normal / medium / epic) */
  couponNormal: '#F5D2D2',
  couponMedium: '#BDE3C3',
  couponEpic: '#F8F7BA',

  border: '#ececef',
  scrim: 'rgba(246, 244, 240, 0.72)',
};

export const couponTierList = [
  { key: 'normal', labelKey: 'coupon_normal', color: colors.couponNormal },
  { key: 'medium', labelKey: 'coupon_medium', color: colors.couponMedium },
  { key: 'epic', labelKey: 'coupon_epic', color: colors.couponEpic },
];
